import {
  VictoryChart,
  VictoryLine,
  VictoryAxis,
  VictoryTooltip,
  VictoryVoronoiContainer,
  VictoryScatter,
} from "victory";

const LineChart = ({ chartData, xlabel, yLabel, y_low, y_high }) => {
  const yValues = chartData && Array.isArray(chartData)
    ? chartData
        .map((d) => d.y)
        .filter((v) => v !== null && v !== undefined)
    : [];
  if (yValues.length > 0) {
    // y_low = Math.max(Math.min(...yValues) - 10, 0);
    y_low = Math.round(Math.min(...yValues) - 10, 1);
    y_high = Math.round(Math.max(...yValues) + 10, 1);
  }
  const interval = Math.ceil((y_high - y_low) / 5);
  const yTicks = Array.from({ length: 6 }, (_, i) => y_low + i * interval);
  return (
    <VictoryChart
      domainPadding={{ x: 20, y: 20 }}
      containerComponent={<VictoryVoronoiContainer />}
      domain={{ y: [y_low, y_high] }}
      padding={{ bottom: 40, top: 40, left: 70, right: 20 }}
    >
      <VictoryAxis
        tickValues={chartData && Array.isArray(chartData) ? Array.from({ length: chartData.length }, (_, i) => i + 1) : []}
        tickFormat={() => ""}
        // tickFormat={chartData && Array.isArray(chartData) ? chartData.map((d) => d.x) : []}
        label={xlabel}
        style={{
          axisLabel: { padding: 30, fill: "#104a5c", fontSize: 20 },
          tickLabels: { fill: "black", padding: 10 },
          ticks: { stroke: "black", size: 3 },
        }}
      />
      <VictoryAxis
        dependentAxis
        tickValues={yTicks}
        label={yLabel}
        style={{
          axisLabel: { padding: 40, fill: "#104a5c", fontSize: 20 },
          tickLabels: { fill: "black", fontSize: 10 },
          ticks: { stroke: "black", size: 3 },
        }}
      />
      <VictoryLine
        data={chartData && Array.isArray(chartData) ? chartData : []}
        interpolation="natural"
        style={{
          data: { stroke: "#8884d8", strokeWidth: 2 },
        }}
      />
    </VictoryChart>
  );
}

export default LineChart;